import { FC } from 'react';
import { ProductsTable } from '../ProductsTable';

export const ProductsTab: FC = () => {
  return <ProductsTable />;
};
